interface SiteInfoMap {
    sampleURLs: readonly string[];
    regex: RegExp;
  }

export const siteInfoMap: { [key: string]: SiteInfoMap } = {
  google: {
    sampleURLs: [
      'https://www.google.co.jp/maps/place/xxx',
      'https://www.google.com/maps/place/xxx',
    ],
    regex: /^(http|https):\/\/(.*)google\.(.+)$/,
  },
  trip_advisor: {
    sampleURLs: [
      'https://www.tripadvisor.jp/Restaurant_Review-xxx.html',
      'https://www.tripadvisor.jp/Hotel_Review-xxx.html',
      'https://www.tripadvisor.jp/Attraction_Review-xxx.html',
    ],
    regex: /^(http|https):\/\/(.*)tripadvisor\.jp\/(Restaurant|Hotel|Attraction)_Review-(.+)$/
  },
  tabelog: {
    sampleURLs: [
      'https://tabelog.com/tokyo/A0000/A000000/xxxxxxx',
      'https://tabelog.com/osaka/A0000/A000000/xxxxxxx'
    ],
    regex: /^(http|https):\/\/(.*)tabelog\.com(.+)$/
  },
  retty: {
    sampleURLs: ['https://retty.me/area/PRE00/ARE00/SUB0000/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)retty\.me(.+)$/,
  },
  hot_pepper_gourmet: {
    sampleURLs: ['https://www.hotpepper.jp/xxxxxxxxxxxxx'],
    regex: /^(http|https):\/\/(.*)hotpepper\.jp(.+)$/,
  },
  hot_pepper_beauty: {
    sampleURLs: ['https://beauty.hotpepper.jp/xxxxxxxxxxxxx'],
    regex: /^(http|https):\/\/(.*)beauty\.hotpepper\.jp(.+)$/
  },
  gnavi: {
    sampleURLs: ['https://r.gnavi.co.jp/xxxxxxxxxxxx'],
    regex: /^(http|https):\/\/(.*)gnavi\.co\.jp(.+)$/,
  },
  yahoo_loco: {
    sampleURLs: [
      'https://yahoo.jp/xxxxxx',
      'https://map.yahoo.co.jp/place?gid=xxxxxxxxxxx',
    ],
    regex: /^(http|https):\/\/(.*)yahoo\.(.+)$/,
  },
  asoview: {
    sampleURLs: ['https://www.asoview.com/base/xxxxxx'],
    regex: /^(http|https):\/\/(.*)asoview\.com(.+)$/
  },
  demaecan: {
    sampleURLs: ['https://demae-can.com/shop/menu/xxxxxxx'],
    regex: /^(http|https):\/\/(www\.|dmc7-org-pc\.)?demae-can\.com\/shop\/menu\/\d{7}(\/.*|\?.*)?$/,
  },
  ikyu: {
    sampleURLs: ['https://restaurant.ikyu.com/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)ikyu\.com(.+)$/,
  },
  ozmall: {
    sampleURLs: ['https://www.ozmall.co.jp/restaurant/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)ozmall\.co\.jp(.+)$/,
  },
  report_clinic: {
    sampleURLs: ['https://report.clinic/detail/L_xxxxxxx/'],
    regex: /^(http|https):\/\/(.*)report\.clinic(.+)$/,
  },
  tribeau: {
    sampleURLs: ['https://tribeau.jp/clinics/xxxx'],
    regex: /^(http|https):\/\/(.*)tribeau\.jp(.+)$/,
  },
  facebook: {
    sampleURLs: ['https://www.facebook.com/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)facebook\.com(.+)$/,
  },
  twitter: {
    sampleURLs: ['https://twitter.com/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)twitter\.com\/(.+)$/,
  },
  instagram: {
    sampleURLs: ['https://www.instagram.com/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)instagram\.com(.+)$/,
  },
  line: {
    sampleURLs: ['https://line.me/xxxxxxx'],
    regex: /^(http|https):\/\/(.*)line\.me(.+)$/,
  },
  taishu_tenpyo: {
    sampleURLs: ['https://www.dianping.com/xxxxxxx'],
    regex: /^(http|https):\/\/([^.]+.)dianping.com(.+)$/,
  }
} as const
